/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import { Button } from 'antd';
import { ImportOutlined } from '@ant-design/icons';
import { IBusinessUnit } from '@/interfaces/business-unit';
import { IDataModal } from '@/interfaces/dataModal';
import ImportAllocationModal from '@/components/import/product-allocation/import-allocation-modal';

interface IProps {
  bus: IBusinessUnit[];
  onImported: () => void;
}

const _importModal: IDataModal<any> = {
  open: false,
};

const ImportExport = ({ bus, onImported }: IProps) => {
  const [importModal, setImportModal] = useState<IDataModal<any>>({
    ..._importModal,
  });

  return (
    <div>
      <Button
        ghost
        type="primary"
        onClick={() => {
          setImportModal({
            open: true,
            id: 'coa',
          });
        }}
      >
        <ImportOutlined />
        Import Excel
      </Button>
      <ImportAllocationModal
        bus={bus || []}
        open={importModal?.open}
        handleOk={function (): void {
          setImportModal({ ..._importModal });
          onImported();
        }}
        handleCancel={function (): void {
          setImportModal({ ..._importModal });
        }}
      />
    </div>
  );
};

export default ImportExport;
